function time (time) {
  let date = time
  let curDate = new Date()
  let oldDate = new Date(date)
  let difTime = curDate.getTime() - oldDate.getTime()
  // 计算天数
  let days = Math.floor(difTime / (24 * 3600 * 1000))
  // 计算天数后剩余的毫秒数
  let remainHoursTime = difTime % (24 * 3600 * 1000)
  let hours = Math.floor(remainHoursTime / (3600 * 1000))
  // 计算小时数后剩余的毫秒数
  let remainMinutesTime = remainHoursTime % (3600 * 1000)
  let minutes = Math.floor(remainMinutesTime / (60 * 1000))

  let remainSecondsTime = remainMinutesTime % (60 * 1000)
  let seconds = Math.floor(remainSecondsTime / 1000)

  if (days >= 365) {
    return 31536000
  }
  if (days >= 30 && days < 365) {
    return 2592000
  }
  if (days < 30 && days >= 1) {
    return 86400
  }
  if (days === 0 && hours >= 1) {
    return 3600
  }
  if (days === 0 && hours === 0 && minutes >= 1) {
    return 60
  }
  if (days === 0 && hours === 0 && minutes === 0 && seconds < 60) {
    return 1
  }
}

export default {
  time
}



// WEBPACK FOOTER //
// ./src/common/time/index.js